define('modules/form_editor/models/custom_terms',['require','exports','module','./base_form_element'],function(require,exports,module){
  "use strict";
  var BaseFormElement = require("./base_form_element");
  var CustomTermsModel = BaseFormElement.extend({
    name: "custom:terms",
    isIntegrable: false,
    defaults: {
      labelText: $.i18n.t("formEditor.label"),
      labelVisible: false,
      isRequired: true,
      widthClass: "one-whole",
      elementId: "",
      termsText: "",
      nameAttr: ""
    },
    initialize: function(attributes) {
      // backwards compatibility with previous versions that hold a termsUrl
      var url = this.get("termsUrl"),
          terms = this.get("termsText");
      if (url && terms) {
        terms = terms.replace("] ", "](" + url + ") ");
        this.set("termsText", terms, {silent: true});
        this.unset("termsUrl", {silent: true});
        this.trigger("change");
      }
      //backwards compat for nameAttr: if not present, get labelText
      this.backwardsCompat(attributes);
    },
    defaultErrorMsgKey: "formEditor.validationMessages.terms"
  });
  module.exports = CustomTermsModel;
});

